import React, { ChangeEvent, FC } from 'react'

export type Item = {
  id: number
  title: string
  image: string
}

export type Props = {
  label: string
  options: Item[]
  selected: number
  onSelectChange: (val: number) => void
}

export const Select: FC<Props> = ({
  label,
  options,
  selected,
  onSelectChange
}) => {
  const selectedImage = options[selected].image

  function changeSelect(e: ChangeEvent<HTMLSelectElement>) {
    const val = Number(e.target.value)
    onSelectChange(val)
  }

  return (
    <div className="Visualizer-group">
      <label className="Visualizer-label">{label}</label>
      <div className="Visualizer-selectGroup">
        <div
          className="Visualizer-imgContainer"
          style={{ backgroundImage: `url(${selectedImage})` }}
        ></div>
        <select
          className="Visualizer-select"
          onChange={changeSelect}
          aria-label={`${label} selector`}
        >
          {options.length > 0 &&
            options.map((item, i) => (
              <option
                selected={selected === item.id ? true : false}
                value={item.id}
                key={i}
              >
                {item.title}
              </option>
            ))}
        </select>
      </div>
    </div>
  )
}
